import { createStyles, Grid, Tooltip } from '@material-ui/core';
import React from 'react';

import { track } from '~/src/dash/analytics/analytics';
import { IStore } from '~/src/dash/reducers/store';
import { IUserStateProps, IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { smallRadius } from '~/src/dash/utils/material-dashboard-react';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';

const LEVEL1GREEN = '#9DFBE2';
const LEVEL5GREEN = '#09AE82';

interface IProps extends IWithStylesProps, IUserStateProps {
  changeTabView: (idx: number) => void;
  totalCompletionPercent: number;
}

export const EndpointRequestScorecardProgressBar = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
      };
    },
    styles: () =>
      createStyles({
        container: {
          '&:hover': {
            cursor: 'pointer',
          },
        },
        newIcon: {
          backgroundColor: 'red',
          width: 30,
          height: 15,
          borderRadius: smallRadius,
          padding: '1px 2px',
          fontSize: 10,
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'flex-start',
          position: 'absolute',
          zIndex: 1,
          left: -10,
          top: -7.5,
        },
        progressBar: {
          display: 'flex',
          flexDirection: 'row',
          width: 80,
          height: 18,
          borderRadius: smallRadius,
          boxShadow: 'inset 0px 3px 6px #CBCBCB',
          marginRight: 7.5,
        },
        progressPercent: {
          color: 'black',
          fontSize: 14,
        },
      }),
  },
  class extends React.Component<IProps> {
    trackEvent = (eventTitle: string) => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      track(
        eventTitle,
        {
          is_super_user,
        },
        this.props.user.user,
      );
    };

    render() {
      const { classes } = this.props;
      return (
        <Grid
          item
          className={classes.container}
          onClick={() => {
            this.props.changeTabView(5); // Recommendations is the 5th tab in Channels
            this.trackEvent('Channel Settings - Progress Bar Shortcut');
          }}
        >
          <Tooltip title='Channel Optimization Score - Click to open recommendations'>
            <Grid
              container
              style={{ display: 'flex', alignItems: 'center', position: 'relative' }}
              direction='row'
            >
              <Grid item className={classes.progressBar}>
                <Grid
                  style={{
                    width: `${this.props.totalCompletionPercent}%`,
                    height: 20,
                    backgroundImage: `linear-gradient(to right, ${LEVEL1GREEN}, ${LEVEL5GREEN})`,
                    borderRadius: smallRadius,
                  }}
                />
              </Grid>
              <Grid item className={classes.progressPercent}>
                {Math.round(this.props.totalCompletionPercent)}% Optimized
              </Grid>
            </Grid>
          </Tooltip>
        </Grid>
      );
    }
  },
);
